import {
    IonButton,
    IonButtons,
    IonContent,
    IonHeader,
    IonIcon,
    IonItem,
    IonLabel,
    IonList,
    IonModal,
    IonSearchbar,
    IonTitle,
    IonToolbar
} from '@ionic/react';
import React, { useEffect, useState } from 'react';
import { closeCircle, radioButtonOffOutline, radioButtonOnOutline} from 'ionicons/icons';
import { modalController } from '@ionic/core';
import './ListBox.css';
import ServerService from '../services/Server';
//import Util from '../services/Util';

const server = new ServerService();
//const util = new Util();

interface ListBoxProps {
    state: any;
    onDismiss:any;
    onSelect:any;
}

const ListBox: React.FC<ListBoxProps> = ({state,onDismiss,onSelect}) => {

  const [pickerState, setShowPicker] = useState({ showPicker:false, title:'', inp:null, id:null, inps:null, onChange:null})
  const [text, setText] = useState("")
  const [items, setItems] = useState([])

  const searchItem = async () => {
    console.log("searchItem()")
    console.log("  pickerState.inp:"+pickerState.inp)
    if(pickerState.inp) {
      console.log("  pickerState.inp.src_url:"+pickerState.inp.src_url)
      var searchCond = ""
      var paramName = "s"
      if (pickerState.inp.src_url) {
        if (pickerState.inp.src_url.indexOf("/master") >= 0) {
          searchCond = "name ilike '%" + text + "%'"
          paramName = "p1"
        }
        else {
          searchCond = text
        }

        const r = await server.listOptions(pickerState.inp,pickerState.id,pickerState.inps,searchCond,paramName)
        setItems(r)
      }
    }

  }

  useEffect(() => {
       //console.log("ListBox useEffect()")
       if (state.showPicker !== pickerState.showPicker) {
         console.log("- change showPicker:"+state.showPicker+","+pickerState.showPicker)
         setShowPicker(state)
       }
  }, [state])

  useEffect(() => {
    console.log("Search Term:"+text)
    if (pickerState.showPicker) {
      searchItem()
    }
  }, [text,pickerState])

  return (
    <IonModal
        className="my-custom-class"
        isOpen={pickerState.showPicker}
        //swipeToClose={true}
        onDidDismiss={() => {
            onDismiss()
        }}
      >
        <IonHeader>
            <IonToolbar>
                <IonButtons slot="end">
                <IonButton onClick={async () => {await modalController.dismiss()}}>
                    <IonIcon slot="icon-only" icon={closeCircle}/>
                </IonButton>
                </IonButtons>
                <IonTitle>{pickerState.title}</IonTitle>
            </IonToolbar>
        
            <IonSearchbar value={text} onIonChange={e => setText(e.detail.value!)}/>
            
        </IonHeader>

        <IonContent>
        <IonList>
            {items?.map((item,i) => {
                //console.log("inp.value:"+pickerState.inp?.value+",item.id:"+item.id)
                return (
                    <IonItem key={i} onClick={(e) => {
                      console.log("ListBox : onClick() :"+e.detail)
                      var ee = new CustomEvent("build",{detail:e.detail});
                      pickerState.onChange(ee)
                      onSelect(item, pickerState.inp);
                      //setShowPicker(prevState => ({...prevState,showPicker:false}))
                      modalController.dismiss()
                    }}>
                        <IonIcon icon={(pickerState.inp?.value === item.id) || (parseInt(pickerState.inp?.value) === parseInt(item.id)) ? radioButtonOnOutline : radioButtonOffOutline}/>
                        <IonLabel className="ion-text-wrap">&nbsp;{item.id ? item.name : "-"}</IonLabel>
                    </IonItem>
                )
            })}
        </IonList>
        </IonContent>
    </IonModal>
  )
        
};

export default ListBox;
